import { Tooltip } from "@/components/modals/Tooltip/Tooltip";
import { ListInPopup } from "@/components/reviews/Reviews/ListInPopup/ListInPopup";
import { useGetNewReviewsQuery, useGetReviewsQuery } from "@/stores/redux/api/reviewsApi";
import { timeStore } from "@/stores/Time";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import styles from "./GeneralBlock.module.css";

export const GeneralBlock = observer(() => {
  const { data } = useGetReviewsQuery(undefined, { pollingInterval: 10000 });
  useGetNewReviewsQuery(data?.last_id ?? 0, {
    pollingInterval: 5000,
    skip: !data?.last_id,
  });
  useEffect(() => {
    timeStore.globalTimeRefreshStart();

    return () => {
      timeStore.globalTimeRefreshStop();
    };
  }, []);

  return (
    <main className={styles.main}>
      <Outlet />
      <ListInPopup />
      <Tooltip />
    </main>
  );
});
